import { useState } from 'react';
import _ from "lodash";

export default function useAccess() {
  const getToken = () => {
    let tokenString;
    if(localStorage.getItem("token") !== undefined && localStorage.getItem("token") !== ''){
        tokenString = localStorage.getItem("token");
        // console.log(tokenString);
        return JSON.parse(tokenString)?.token;
    }
    return undefined;
  };

  const getUserInfo = () => {
    let userInfoString;
    if(localStorage.getItem("userInfo") !== undefined && localStorage.getItem("userInfo") !== ''){
        userInfoString = localStorage.getItem("userInfo");
        // console.log(userInfoString);
        return JSON.parse(userInfoString);
    }
    return undefined;
  }

  const [token, setToken] = useState(getToken());

  const saveAccess = res => {
    // sessionStorage.setItem('token', JSON.stringify(userAccess));
    if(res["token"]){
        localStorage.setItem("token", JSON.stringify(res["token"]));
        localStorage.setItem("userInfo",JSON.stringify(_.omit(res,["token"])));
        setToken(res["token"]);
    }
  };

  const deleteAccess = () => {
    // console.log("deleteAccess executed");
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
  }

  return {
    setAccess: saveAccess,
    getToken: getToken,
    getUserInfo: getUserInfo,
    removeAccess : deleteAccess
  }
}